// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise"
import "core-js/es6/string"
import "core-js/es7/array"

import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
import App from "./App"
import router from "./router"
import store from "./store"
import i18n from "./utils/i18n"
import {routerEvents} from '@/mixins/routerEvents'
import {dateMethods} from '@/mixins/date'
import {format} from '@/mixins/format'
import {table} from '@/mixins/table'
import {color} from '@/mixins/color'
import {currency} from '@/mixins/currency'
import {formMethods} from '@/mixins/form'
import editor from 'vue2-ace-editor'

import Vuelidate from "vuelidate"
import VueNoty from "vuejs-noty"
import Multiselect from "vue-multiselect"
import Treeselect from '@riophae/vue-treeselect'
import VCalendar from "v-calendar";
import {VueMaskDirective} from "v-mask";
import {ServerTable, ClientTable, Event} from "vue-tables-2";
import ColumnLocation from "@/components/table/ColumnLocation"
import ColumnSelect from "@/components/table/ColumnSelect"
import ColumnCheck from "@/components/table/ColumnCheck"
import ColumnSubscriptions from "@/components/table/ColumnSubscriptions"
import ColumnDate from "@/components/table/ColumnDate"
// import "v-calendar/lib/v-calendar.min.css";
import Loader from "@/components/global/loader";
import ShortText from "@/components/table/ShortText"
import ColumnAction from "@/components/table/ColumnAction"
import CentsToBills from "@/components/table/CentsToBills"
import ColumnUpdate from "@/components/table/ColumnUpdate"
import ColumnName from "@/components/table/ColumnName"
import ColumnStatus from "@/components/table/ColumnStatus"
import NumberOrUnlimited from "@/components/table/NumberOrUnlimited"
import GroupSelect from "@/components/global/groupSelect"
import cardWithAside from "@/components/global/cardWithAside"
import modal from "@/components/global/modal"
import formButtons from "@/components/global/formButtons"
import help from "@/components/global/help"
import vuedraggable from "vuedraggable/src/vuedraggable";
import customTooltip from "./components/global/customTooltip";

Vue.component("multiselect", Multiselect);
Vue.component("treeselect", Treeselect);
Vue.component("column-location", ColumnLocation);
Vue.component("column-select", ColumnSelect);
Vue.component("column-check", ColumnCheck);
Vue.component("column-subscriptions", ColumnSubscriptions);
Vue.component("column-date", ColumnDate);
Vue.component("loader", Loader);
Vue.component("column-location", ColumnLocation);
Vue.component("column-check", ColumnCheck);
Vue.component("column-subscriptions", ColumnSubscriptions);
Vue.component("short-text", ShortText);
Vue.component("cents-to-bills", CentsToBills);
Vue.component("column-update", ColumnUpdate);
Vue.component("column-action", ColumnAction);
Vue.component("column-name", ColumnName);
Vue.component("column-status", ColumnStatus);
Vue.component("number-unlimited", NumberOrUnlimited);
Vue.component("group-select", GroupSelect);
Vue.component("card-with-aside", cardWithAside);
Vue.component("modal", modal);
Vue.component("form-buttons", formButtons);
Vue.component("editor", editor);
Vue.component("help", help);
Vue.component("draggable", vuedraggable);
Vue.component("customTooltip", customTooltip);


Vue.use(VCalendar, {
  firstDayOfWeek: 2
});
Vue.use(ServerTable, {}, false, "bootstrap4", "default");
Vue.use(ClientTable, {}, false, "bootstrap4", "footerPagination");
Vue.use(Event);
Vue.use(VueNoty, {
  theme: "bootstrap-v4"
});
Vue.use(Vuelidate);
Vue.use(BootstrapVue);

Vue.mixin(routerEvents);
Vue.mixin(dateMethods);
Vue.mixin(format);
Vue.mixin(table);
Vue.mixin(color);
Vue.mixin(currency);
Vue.mixin(formMethods);

Vue.directive('mask', VueMaskDirective);

Vue.prototype.$bus = new Vue();

console.log(new Date());

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  template: "<App/>",
  components: {
    App
  }
})
